import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
import helper from '../util/helpers';
import DefaultRoutes from './subRoutes/default';
import MemberRoutes from './subRoutes/member';

import Nprogress from 'nprogress';
import { parseLoginToken } from '@/util';

Vue.use(Router);
Vue.use(Meta);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/dashboard',
      name: 'Layout',
      component: () => import('@/components/layout'),
      children: [...DefaultRoutes, ...MemberRoutes]
    },
    {
      path: '*',
      redirect: '/dashboard'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 30 },
        behavior: 'smooth'
      };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  Nprogress.start();
  const isValidToken = checkValidToken();
  try {
    if (isValidToken) {
      if (to.path.toLowerCase() === '/member/login' && parseLoginToken().accountId) {
        next(DefaultRoutes[0].path);
      }
      next();
    } else if (to.meta.requiresAuth === false) {
      next();
    } else {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('agent-menus');
      next('/member/login');
    }
  } catch (e) {
    console.log(e);
  }
});

router.afterEach((to, from) => {
  Nprogress.done();
});

const checkValidToken = () => {
  const now = helper.convertTimeToMomentType(helper.getCurrentUTCDateTimeAsFormatted());
  return !!localStorage.getItem('token') && now.isBefore(helper.convertTimeToMomentType(parseLoginToken().expireTime));
};

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js